module.exports = __webpack_public_path__ + "static/media/chemistry.d1043977.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/undergrad/chemistry.jpg
// module id = 482
// module chunks = 0